import { Box, Rating, Typography } from '@mui/material';
import ErrorMessage from '@shared/components/ErrorMessage';
import { screenMdMin } from '@shared/styles';

interface ReviewRatingProps {
  value: string;
  handleChange?: any;
  label: string;
  name: string;
  errors?: any;
  isReadOnly?: boolean;
}

function ReviewRating(props: ReviewRatingProps) {
  const { value, handleChange, label, name, errors, isReadOnly } = props;
  return (
    <Box
      sx={{
        flexDirection: 'column',
        width: '100%',
        ...(handleChange && {
          [`@media ${screenMdMin}`]: {
            width: '22%',
          },
        }),
      }}
    >
      <Typography component="legend">
        <strong style={{ margin: 'var(--spacing-sm) 0' }}>{label}</strong>
      </Typography>
      <Rating
        onChange={handleChange}
        name={name}
        size="large"
        value={Number(value)}
        readOnly={isReadOnly}
        sx={{ margin: 'var(--spacing-sm) 0' }}
      />
      {errors && !value && errors[name] && (
        <ErrorMessage key={`${name}-error`} error={errors[name]} />
      )}
    </Box>
  );
}

export default ReviewRating;
